import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml } from '../../../utils/textFunctions'
import '../../../styles/assets/css/pages/form5.css'
import { loadLocationWithMessage } from '../../../actions/location'
import { scid_yesno, scid_ynmb, tobacco_scale, audit_c1_scale, audit_c2_scale,
audit_c3_scale, mini_borderline, mini_eligible } from '../variables/assessments/scid.js'

import PatientHead3 from "../patient/patient_head3"
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import Button from '@material-ui/core/Button'
import WarningIcon from '@material-ui/icons/Warning'
import ReactHtmlParser from 'react-html-parser'

class ScidResult extends Component {
  constructor() {
      super()
      //var [fields, setFields] = useState([{ value: null }])
      this.state = {
          status: false,
          message: '',
          dataItems: [],
      }
  }

  componentDidMount() {
    this.getData()
    window.scrollTo(0, 0)
  }

  getData = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/patient_assessment/view_scid_result',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: this.props.match.params.pid,
      }
    })
    .then((result) => {
      if(result['data'] != 0) {
        this.setState({
          dataItems: result['data'][0]
        })
      }
    })
  }

  findLabelByValue(arr, searchValue) {
    var label = ''
    var result = arr.find(obj => { return obj.value === searchValue })
    if(typeof result !== "undefined") {
      label = result.label
    }
    return label
  }

  render() {
    return (
      <div className="admin_patient_detail box_border4 mini_result">
        <div className="row">
          <div className="small-12 columns headerPage1">SCID Result</div>
        </div>
        <div className="row">
          <div className="small-12 columns ">
            <div className="box_border5">
              <PatientHead3 />
              <div className="row">
                <div className="small-12 columns box_inner2 top_space1">
                  <div className="small-12 columns">

                  <div className="small-12 columns box5 top_space1">
                    <div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">A70. Has there been one or more Manic Episodes?</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['a70'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Currently Manic</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['a70_manic'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Currently Depressed</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['a70_depressed'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                      </div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">A71. Has there been at least one Hypomanic Episode and at least one Major Depressive Episode?</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['a71'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Currently Hypomanic</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['a71_hypomanic'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Currently Depressed</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['a71_depressed'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">A72. Have symptoms characteristic of a bipolar and related disorder (e.g., elevated or irritable mood) that cause clinically significant distress or impairment in social, occupational, or other important areas of functioning predominated the clinical presentation?</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['a72'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">A73. Has there been at least one Major Depressive Episode?</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['a73'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Currently in an episode</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['a73_current_episode'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">A74. Have symptoms characteristic of a depressive disorder (e.g. depredded mood or loss of interest) that cause clinically significant distress or impairment in social, occupational, or other important areas of functioning predominated the clinical presentation?</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['a74'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                      </div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">B13. Possible Lifetime Psychotic Disorder?</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['b13'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">B14. Possible Current Psychotic Disorder?</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['b14'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                      </div>
                      <div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom text_align_right">
                            <a href={"/admin/assessments/edit_scid1/"+this.props.match.params.pid+"/edit"} className="edit_button1" >
                                Edit
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="small-12 columns box5 top_space1">
                    <div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">C13. Alcohol Use Disorder (past year)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['c13'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Mild Alcohol Use Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['c13_mild'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Moderate Alcohol Use Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['c13_moderate'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Severe Alcohol Use Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['c13_severe'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                      </div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">C35. Nonalcohol Substance Use Disorder (past year)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['c35'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Mild Nonalcohol Substance Use Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['c35_mild'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Moderate Nonalcohol Substance Use Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['c35_moderate'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Severe Nonalcohol Substance Use Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['c35_severe'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">D16. Panic Disorder (current)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['d16'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">D22. Agoraphobia (current)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['d22'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">D28. Social Anxiety Disorder (current)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['d28'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">D37. Generalized Anxiety Disorder (current)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['d37'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                      </div>
                      <div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom text_align_right">
                            <a href={"/admin/assessments/edit_scid2/"+this.props.match.params.pid+"/edit"} className="edit_button1" >
                                Edit
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="small-12 columns box5 top_space1">
                    <div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">E5. Obsessive-Compulsive Disorder (current)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['e5'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">G18. Posttraumatic Stress Disorder (current)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['g18'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">H3. Anorexia Nervosa (current)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['h3'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">H7. Bulimia Nervosa (current)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['h7'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">H14. Binge-Eating Disorder (current)</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['h14'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                      </div>
                      <div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom text_align_right">
                            <a href={"/admin/assessments/edit_scid3/"+this.props.match.params.pid+"/edit"} className="edit_button1" >
                                Edit
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="small-12 columns box5 top_space1">
                    <div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">J1. Probable Mental Disorder due to Another Medical Condition</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['j1'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-11 columns">Medical condition: {this.state.dataItems['j1_med_condition']}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Depressive Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['j1_depress'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Bipolar and Related Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['j1_bipolar'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Anxiety Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['j1_anxiety'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Obsessive-Compulsive and Related Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['j1_ocd'])}</div>
                        </div>

                        <div className="small-12 columns sep_line1">&nbsp;</div>
                      </div>
                      <div className="small-12 columns">
                        <div className="row no_margin_bottom">
                          <div className="small-10 columns">J2. Probable Substance/Medication-Induced Mental Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['j2'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-11 columns">Medical condition: {this.state.dataItems['j2_med_condition']}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Depressive Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['j2_depress'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Bipolar and Related Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['j2_bipolar'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Anxiety Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['j2_anxiety'])}</div>
                        </div>
                        <div className="row no_margin_bottom">
                          <div className="small-1 columns">&nbsp;</div>
                          <div className="small-9 columns">Obsessive-Compulsive and Related Disorder</div>
                          <div className="small-2 columns">{this.findLabelByValue(scid_ynmb, this.state.dataItems['j2_ocd'])}</div>
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                      </div>
                      <div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom text_align_right">
                            <a href={"/admin/assessments/edit_scid4/"+this.props.match.params.pid+"/edit"} className="edit_button1" >
                                Edit
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>



                  </div>

                  <div className="small-12 columns box5 top_space1">
                  <div className="small-12 columns">
                    <div className="row no_margin_bottom">
                      <div className="small-9 columns">Tobacco 30-day use: Has the patient used any tobacco product in the past 30 days?</div>
                      <div className="small-3 columns">{this.findLabelByValue(tobacco_scale, this.state.dataItems['tobacco'])}</div>
                    </div>
                    <div className="small-12 columns sep_line1">&nbsp;</div>
                  </div>

                  <div>
                  <div className="small-12 columns">
                    <div className="row no_margin_bottom">
                      <div className="small-9 columns">AUDIT-C: 1. How often do you have a drink containing alcohol?</div>
                      <div className="small-3 columns">{this.findLabelByValue(audit_c1_scale, this.state.dataItems['audit_c_1'])}</div>
                    </div>
                    <div className="small-12 columns sep_line1">&nbsp;</div>
                  </div>

                  <div className="small-12 columns">
                    <div className="row no_margin_bottom">
                      <div className="small-9 columns">AUDIT-C: 2. How many standard drinks containing alcohol do you have on a typical day?</div>
                      <div className="small-3 columns">{this.findLabelByValue(audit_c2_scale, this.state.dataItems['audit_c_2'])}</div>
                    </div>
                    <div className="small-12 columns sep_line1">&nbsp;</div>
                  </div>

                  <div className="small-12 columns">
                    <div className="row no_margin_bottom">
                      <div className="small-9 columns">AUDIT-C: 3. How often do you have 6 drinks or more on one occasion?</div>
                      <div className="small-3 columns">{this.findLabelByValue(audit_c3_scale, this.state.dataItems['audit_c_3'])}</div>
                    </div>
                  </div>

                  </div>
                  <div className="small-12 columns sep_line1">&nbsp;</div>
                  <div>
                    <div className="small-12 columns">
                      <div className="row no_margin_bottom text_align_right">
                        <a href={"/admin/assessments/edit_scid5/"+this.props.match.params.pid+"/edit"} className="edit_button1" >
                            Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  </div>

                  <div className="small-12 columns box5 top_space1">
                  <div>{mini_borderline.map(each =>
                    <div className="small-12 columns">
                      <div className="row no_margin_bottom">
                        <div className="small-9 columns">{each.value}. {each.label}</div>
                        <div className="small-3 columns">
                        {this.findLabelByValue(scid_yesno, this.state.dataItems['bdl'+each.value])}
                        </div>
                      </div>
                      <div className="small-12 columns sep_line1">&nbsp;</div>
                    </div>)}
                  </div>
                  <div>
                    <div className="small-12 columns">
                      <div className="row no_margin_bottom text_align_right">
                        <a href={"/admin/assessments/edit_scid6/"+this.props.match.params.pid+"/edit"} className="edit_button1" >
                            Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  </div>

                  <div className="small-12 columns box5 top_space1">
                    <div>
                      <div className="small-12 columns">
                        <div className="small-12 columns"><span className="bold">Result: </span>
                          {this.findLabelByValue(mini_eligible, this.state.dataItems.bd_result)}
                        </div>
                        <div className="small-12 columns"><span className="bold">Note: </span><br />
                          {ReactHtmlParser(this.state.dataItems.note)}
                        </div>
                        <div className="small-12 columns sep_line1">&nbsp;</div>
                      </div>
                      <div>
                        <div className="small-12 columns">
                          <div className="row no_margin_bottom text_align_right">
                            <a href={"/admin/assessments/edit_scid7/"+this.props.match.params.pid+"/edit"} className="edit_button1" >
                                Edit
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
  }
}

/*<div className="small-12 columns box5 top_space1">
<div>{mini_q_c.map(each =>
  <div className="small-12 columns">
    <div className="row no_margin_bottom">
      <div className="small-9 columns">C{each.value}. {each.label}</div>
      <div className="small-3 columns">
      {this.findLabelByValue(mini_scale1, this.state.dataItems['c'+each.value])}
      </div>
    </div>
    <div className="small-12 columns sep_line1">&nbsp;</div>
  </div>)}
</div>
<div>
  <div className="small-12 columns">
    <div className="row no_margin_bottom text_align_right">
      <a href={"/admin/assessments/edit_mini2/"+this.props.match.params.pid+"/edit"} className="edit_button1" >
          Edit
      </a>
    </div>
  </div>
</div>
</div>*/

const mapStateToProps = (state) => {
  //console.log('patientstate STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ScidResult)
